import React from "react";
import PageHeader from "../../components/ui/PageHeader";
import DevHouseDetails from "../../components/ui/DevHouseDetails";

const DevHouseView = () => {

  const propertyData = JSON.parse(localStorage.getItem("property"));
  

  return (
    <div>
      <PageHeader title={propertyData?.name} text={`Home/Developer/Properties details`} />
      <DevHouseDetails />
    </div>
  );
};

export default DevHouseView;
